@if(showBulgariBackground){
<app-bulgari-background></app-bulgari-background>
}
<app-header></app-header>
<app-sidenav></app-sidenav>
<div [id]="scrollService.SCROLL_ID" class="scroll-container container-fluid">
  <router-outlet />
  <button class="scroll-top btn btn-dark" [class.visible]="showScrollButton" [disabled]="!showScrollButton"
    [attr.aria-label]="'Scroll Top'|translate" (click)="scrollService.scrollTop()"></button>
</div>
<app-footer></app-footer>
